import { render, staticRenderFns } from "./ManualValuationConfirmation.vue?vue&type=template&id=51c2d1d9"
import script from "./ManualValuationConfirmation.vue?vue&type=script&lang=js"
export * from "./ManualValuationConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports